<template>
  <div class="wmx-card">
    <div class="top">
      <!-- <div class="type">
        为民行
      </div> -->
      <div class="content">
        <div class="xm">{{item.createBy_dictText}}</div>
        <div class="desc">{{item.nr}}</div>
        <div class="fj" v-if="item.yy">
          <span class="span">语音</span>
           <audio-player
                      ref="audioPlayer"
                      :audio-list="item.yy.split(',')"
                      :isLoop="false"
                      theme-color="#3f8ffb"
            /> 
        </div>
        <div class="fj" v-if="item.tp">
          <span class="text">图片</span>
          <!-- <tr-image :list="item.tp.split(',')" width="170"></tr-image> -->
          <div class="img-wrap">
          <img v-for="(img,index) in item.tp.split(',')" :key="index" :src="img" class="img" @click="previewImage(index,item.tp.split(','))"/>
          </div>
        </div>
        <div class="fj" v-if="item.dsp">
          <span class="text">视频</span>
          <div class="flex-wrap">
            <div class="add_picture" v-for="(path, inx) in item.dsp.split(',')" :key="inx" @click="playVideo(path)">
              <van-icon name="play-circle" size="40" class="video-play" />
            </div>
          </div>

        </div>
        <div class="time">
          <van-icon name="clock" style="margin-right: 4px;" size="14" />{{item.createTime}}
        </div>
        <div class="cl-p">
          <div style="font-size: 14px;font-weight: bold;">办理进度</div>
          <div v-if="type!='yb'">
              <span class="tag" @click="clickCl">立即处理</span>
            <!-- <u-tag text="立即处理" type="error" mode="plain" shape="circle" size="mini" style="margin-right: 10px;"
              @click="clickCl" /> -->
          </div>
        </div>
      </div>
    </div>
  
   <div class="bottom">
      <div :class="{active1:!sfzk}" class="lc-p">
             <div v-for="(lc,i) in item.lcList" :key="i" class="lc">
              <div class="u-node">
                <van-icon name="pushpin-fill" color="#fff" :size="30"/>
              </div>
              <div class="lc-content">
                <div class="u-order-title">{{lc.createTime}}</div>
                <div class="u-order-content">处理人:{{lc.createBy_dictText}}</div>
                <div class="u-order-content">处理方式：{{lc.clfs_dictText}}</div>
                <div class="u-order-content">处理内容:{{lc.clnr}}</div>
              </div>
              </div>
      </div>
    </div> 
      <div class="sq" @click="zk()" v-if="!sfzk">展开
        <van-icon name="arrow-down" size="18"/>
      </div>
      <div class="sq" @click="sq()" v-else>收起
        <van-icon name="arrow-up" size="18"/>
      </div>
  </div>

</template>

<script>
import { ImagePreview } from 'vant'
import { getAction, postAction } from '@/api/manage'
import AudioPlayer from '@liripeng/vue-audio-player'
  export default {
  components: {
    AudioPlayer
  },
    props: {
      item: {
        type: Object,
        default () {
          return {}
        }
      },
      type: {
        type: String,
        default: 'db'
      }
    },
    data() {
      return {
        lcList: [],
        show: false,
        content: '',
        slqx: ['jbzj', 'jbhybm', 'jbsjwgy', 'jbejwgy', 'jbyjwgy', 'sb', 'dfh'],
        blqx: ['sl'],
        roleqx: ['xjgly', 'xjxbdw'],
        sfzk:false,
      }
    },

    methods: {
      clickItem(item) {

      },
      zk() {
        this.sfzk = true;
        // this.isactive = !this.isactive
        // var params = {
        //   flowId: this.item.flowId
        // }
        // this.$http.get('/zhshj/wghgridwork/query/by/flowdate/List', {
        //   params: params
        // }).then(res => {
        //   if (res.data.success) {
        //     this.lcList = this.convert(res.data.result);
        //   }
        // })
      },
      sq() {
        this.sfzk = false;
      },
     playVideo(path) {
      var obj = { url: path }
      this.$router.push({
        path: '/common/video-play',
        query: obj,
      })
    },
      previewImage(index, imgList) {
          ImagePreview({
            images: imgList,
            startPosition: index,
          })
      },
      getSjdjType(type) {
        var sjdjType = type == "03" ? 'primary' : type == "04" ? 'success' : type == "01" ? 'error' : type == "02" ?
          'warning' : 'info';
        return sjdjType;
      },
      playVideo(path) {
        var obj = {
          "src": path
        }
        this.$router.push({
          url: "/pages/home/video-play",
          params: obj
        })
      },
      matchType(fileName) {
        // 后缀获取
        var suffix = '';
        // 获取类型结果
        var result = '';
        try {
          var flieArr = fileName.split('.');
          suffix = flieArr[flieArr.length - 1];
        } catch (err) {
          suffix = '';
        }
        // fileName无后缀返回 false
        if (!suffix) {
          result = false;
          return result;
        }
        // 图片格式
        var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
        // 进行图片匹配
        result = imglist.some(function(item) {
          return item == suffix;
        });
        if (result) {
          result = 'image';
          return result;
        };
        // 匹配 视频
        var videolist = ['mp4', 'm2v', 'mkv', 'amr'];
        result = videolist.some(function(item) {
          return item == suffix;
        });
        if (result) {
          result = 'video';
          return result;
        };
        // 匹配 音频
        var radiolist = ['mp3', 'wav', 'wmv'];
        result = radiolist.some(function(item) {
          return item == suffix;
        });
        if (result) {
          result = 'radio';
          return result;
        }
        // 其他 文件类型
        result = 'other';
        return result;
      },
      convert(list) {

        var newList = list.map(val => {

          var imgList = [];
          var videoList = [];
          var audioList = [];
          if (val.commentFiles) {
            let arr = val.commentFiles.split(',');
            for (var i = 0; i < arr.length; i++) {
              var item = arr[i];
              if (this.matchType(item) == "image") {
                imgList.push(item)
              } else if (this.matchType(item) == "video") {
                videoList.push(item)
              } else if (this.matchType(item) == "radio") {
                let obj = {
                  'url': item
                }
                audioList.push(obj);
              }
            }
          }
          val.imgList = imgList;
          val.videoList = videoList;
          val.audioList = audioList;

          return val;
        })
        return newList;
      },
      clickCl() {
        const {id,dqzt} = this.item;
        var params = {
          id,dqzt
        };
        this.$router.push({path:'/gzfw/sbdwmx-cl',query:params})
      },
    }
  }
</script>

<style lang="less" scoped>
  .wmx-card {
    background-color: #FFF;
    margin-bottom: 10px;
    width: 100%;

    .top {
      display: flex;

      .type {
        width: 65px;
        height: 35px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        background-color: #1D6DDB;
        border-radius: 0 18px 18px 0;
        line-height: 35px;
        margin-top: 10px;
      }

      .content {
        flex: 1;
        padding: 12px 12px 12px 15px;

        .xm {
          font-size: 15px;
          color: #1A1A1A;
          font-weight: bold;
          margin-bottom: 4px;
        }

        .desc {
          font-size: 14px;
          margin-bottom: 10px;
        }



        .time {
          color: #a3a3a3;
          font-size: 13px;
          display: flex;
          align-items: center;
        }

        .cl-p {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
        }

      }
    }

    .bottom {}

    .sq {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #dedede;
      color: #1D6DDB;

      .icon {
        margin-left: 10px;
      }
    }
  }
  .active1 {
    display: none !important;
  }
  .lc-p {
    padding: 0 12px 12px 12px;


    .lc{
      display: flex;
    }

    .u-node {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1D6DDB;
      margin-top: 6px;
      font-size: 12px;
      color: #FFF;
    }

    .lc-content {
      flex: 1;
      padding-left: 10px;
      padding-top: 5px;

      .u-order-title {
        color: #333333;
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        margin-top: 5px;
      }

      .u-order-title.unacive {
        color: rgb(150, 150, 150);
      }

      .u-order-content {
        color: #333;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .u-order-desc {
        color: rgb(150, 150, 150);
        font-size: 14px;
        margin-bottom: 8px;
      }

      .u-order-time {
        color: rgb(150, 150, 150);
        font-size: 13px;
      }
    }

  }

  .fj {
    padding-bottom: 10px;

    .text {
      display: block;
      margin-bottom: 10px;
    }

    .flex-wrap {
      display: flex;
      flex-wrap: wrap;
    }

    .add_picture {
      width: 85px;
      height: 85px;
      margin: 0 10px 10px 0;
      position: relative;
      background-color: #000;

      .video-play {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -20px;
        margin-left: -20px;
        color: #AAAAAA;
      }
    }



  }

  .tag{
    display: inline-block;
    padding: 2px 6px;
    font-size: 12px;
    background:#c52525;
    color: #FFF;
    border-radius: 12px;
  }
.img-wrap{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
   .img{
    width: 80px;
    height: 80px;
    margin: 0 8px 8px 0;
    border-radius: 8px;
  }
}
 
</style>